import React from 'react';
import { View } from '../../component';
import BottomBar from '../../component/bottom_bar';
import GamesPosterCard from '../../component/games_poster_card';
import MatchCardWrapper from '../../component/match_card_wrapper';
import constants from '../../constants';
import DefaultContainer from '../default_container';
import './index_mWeb.css';

interface Props {
  suggestionsHandler: any;
  onClickViewAll: any;
  topGame: any;
  isLeaderBoardGames: Boolean;
  quizGames: any;
  sportsGames: any;
  arcadeGames: any;
  racingGames: any;
  puzzleGames: any;
  strategyGames: any;
}

const LeaderBoardPvpGamesMWeb = ({
  suggestionsHandler,
  onClickViewAll,
  isLeaderBoardGames,
  topGame,
  quizGames,
  sportsGames,
  arcadeGames,
  racingGames,
  puzzleGames,
  strategyGames
}: Props) => {
  return (
    <DefaultContainer isNavigationHeader={true} navigationTitle={'Player Vs Player Games'}>
      <View className="leaderBoardGames__wrapper__mWeb">
        <div className="leaderBoardGames__weekTopRankedGame__wrapper__mWeb">
          <View className="leaderBoardGames__title__mWeb">
            {isLeaderBoardGames
              ? 'LeaderBoard Game of the Week'
              : 'Player vs Player Game of the Week'}
          </View>
          <div className="leaderBoardGames__weekTopRankedGame__img__container__mWeb">
            <img
              className="leaderBoardGames__weekTopRankedGame__img__mWeb"
              src={topGame.gameImage}
            />
          </div>
          <div className="leaderBoardGames__weekTopRankedGame__info__container__mWeb">
            <div className="leaderBoardGames__weekTopRankedGame__title__mWeb">
              {topGame.gameName}
            </div>
            <div className="leaderBoardGames__weekTopRankedGame__description__mWeb">
              {' '}
              {`${topGame.gameDescription1} ${topGame.gameDescription2}`}
            </div>
            <button
              className="leaderBoardGames__playNow__btn__mWeb"
              onClick={() => suggestionsHandler(topGame)}>
              Play Now
            </button>
          </div>
          <div></div>
        </div>
        {isLeaderBoardGames && (
          <React.Fragment>
            <MatchCardWrapper
              title={'New Games'}
              iconSrc={constants.Images.new}
              onClickHandler={() => {
                onClickViewAll('/viewall/newgames');
              }}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {constants.MiniGames.newGamesList.slice(0, 4).map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              title={'Racing Games'}
              iconSrc={constants.Images.racing}
              onClickHandler={() => onClickViewAll('/viewall/racing')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {racingGames.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              title={'Sports Games'}
              iconSrc={constants.Images.sports}
              onClickHandler={() => onClickViewAll('/viewall/sports')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {sportsGames.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              iconSrc={constants.Images.arcade}
              title={'Arcade Games'}
              onClickHandler={() => onClickViewAll('/viewall/arcade')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {arcadeGames.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              iconSrc={constants.Images.quiz}
              title={'Quiz Games'}
              onClickHandler={() => onClickViewAll('/viewall/quiz')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {quizGames.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              iconSrc={constants.Images.puzzles}
              title={'Puzzle Games'}
              onClickHandler={() => onClickViewAll('/viewall/puzzles')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {puzzleGames.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              iconSrc={constants.Images.strategy}
              title={'Strategy Games'}
              onClickHandler={() => onClickViewAll('/viewall/strategy')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {strategyGames.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
              </div>
            </MatchCardWrapper>
          </React.Fragment>
        )}
        {!isLeaderBoardGames && (
          <React.Fragment>
            <MatchCardWrapper
              iconSrc={constants.Images.arcade}
              title={'Arcade Games'}
              onClickHandler={() => onClickViewAll('/viewall/arcade')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {arcadeGames
                  .filter((game: any) => game.gameType === 'playerVsPlayer')
                  .map((item: any, idx: any) => (
                    <React.Fragment key={idx}>
                      <GamesPosterCard
                        item={item}
                        idx={idx}
                        onGamePosterClick={suggestionsHandler}
                        isFooter={false}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              iconSrc={constants.Images.quiz}
              title={'Quiz Games'}
              onClickHandler={() => onClickViewAll('/viewall/quiz')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {quizGames
                  .filter((game: any) => game.gameType === 'playerVsPlayer')
                  .map((item: any, idx: any) => (
                    <React.Fragment key={idx}>
                      <GamesPosterCard
                        item={item}
                        idx={idx}
                        onGamePosterClick={suggestionsHandler}
                        isFooter={false}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </MatchCardWrapper>
            <MatchCardWrapper
              iconSrc={constants.Images.strategy}
              title={'Strategy Games'}
              onClickHandler={() => onClickViewAll('/viewall/strategy')}>
              <div className="homepage_games_match_card_wrapper_mWeb">
                {strategyGames
                  .filter((game: any) => game.gameType === 'playerVsPlayer')
                  .map((item: any, idx: any) => (
                    <React.Fragment key={idx}>
                      <GamesPosterCard
                        item={item}
                        idx={idx}
                        onGamePosterClick={suggestionsHandler}
                        isFooter={false}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </MatchCardWrapper>
          </React.Fragment>
        )}
      </View>
      <BottomBar />
    </DefaultContainer>
  );
};

export default LeaderBoardPvpGamesMWeb;
